
export default {
  data() {
    return {
      options: [
        {
          name: 'data',
          label: 'Podatak',
          type: 'text',
        },
      ],
    }
  },
  methods: {
    toggleList(e, index) {
      const el = e.currentTarget
      const all = Array.from(document.querySelectorAll('.moja-klasa'))
      all.forEach((item) => {
        item.classList.remove('active')
      })
      el.classList.add('active')

      setTimeout(() => {
        const id = `anchor${index}`
        window.location.hash = id
      }, 100)
    },
  },
}
